<template>
  <CalculatorScaffold />
</template>

<script>
import CalculatorScaffold from './components/CalculatorScaffold.vue'

export default {
  name: 'App',
  components: {
    CalculatorScaffold
  }
}
</script>

<style lang="scss">
  @import 'mdb-vue-ui-kit/src/scss/index.free.scss';
  @import '@lifetime-gallagher/lifetime-slider-input/themes/default.scss';
  @import "~@/scss/main.scss";
</style>
